import { Drawable } from "../anim/drawable";
import Screen, { ScreenState } from "../anim/screen";
import { Text } from "../anim/text";
import { CircularButton, IconButton } from "../anim/button";
import { PNG, SVG } from "../anim/image";
import AlbumArt from "../anim/albumArt";
import { Player } from "textalive-app-api";
import { RandomNumber, shuffleArray, sleep } from "../utils/common";
import { Word } from "../anim/word";
import { PointsCounter } from "../anim/pointCounter";
import { rgb } from "../utils/color";
import RenderableSegmentationMask from "../anim/segmentationMask";
import ScoreBoard from "../anim/scoreBoard";
import GameManual from "../anim/gameManual";

// COLOR PALLETS:
// https://coolors.co/eb5e55-e4ff1a-e8aa14-6cd4ff-ff5714
// https://coolors.co/eb5e55-e8aa14-e4ff1a-6cd4ff-a8ea8d-bec66f-ff5714


// TODO:
// <all done!>

// COMPLETED:
// Game Start transition (after music select)
// Link audio fade in, fade out & chorusLoop to Album Object
// Combo Count
// Modify random function to prevent big fluctuations
// COLOR SCHEME + Blur effect around lines to help with neon effect
// BUG: Hover does not work properly on display resizing.
// Music Loading Sign at Select Menu, retry music load if fail
// Body Image Segmentation
// Bug: Select Menu. Remove song title when screen exit, otherwise title is displayed during back btn transition.
// IMP: Disable button after press & Prevent Button Double Click/Prevent simultaneous Player call
// Add AlbumArt Animations/Improvements
// Add options to select cursor/webcam mode
// Update page titles & hide cursor in webcam mode.
// Add Settings Modal
// create rectResizeV2, scale based on a center
// Cursor/Touch Mode: register clicks and press instead of hover; consider removing red dot
// Possible Bug: Displayed cursor radius may not reflect actual radius due to scalling.
// Ask user to rotate screen if at portrait rotation.
// End Game stats
// Full screen toggle using double click
// Instructional images
// Cursor Mode: real fullscreen do not exist in iPhones and iPads, set bounding box based on visibility on screen.
// Select Menu Background
// Webcam mode show popup to wait if taking too long.

// CANCELED:
// Create press and hold option for Word Object
// Maybe make the game easier (allow some clicks before word start time?)
// Move word if it's bounding circle is out of screen
// Change cursor on button hover so that it is easier to see. 
// Fix Camera problem (game may break if webcam resolution > screen resolution) [Not a problem]

class MainGame{
  activeScreens = /** @type {Screen[]} */ (new Array());
  songData = new Array();
  selectedSongIndex = 0;
  currentlyActiveScreen = /** @type {string | undefined} */ (undefined);


  constructor(canvasCtx, width, height, offsetX, offsetY, mode, lang){
    this.canvasCtx = canvasCtx;
    this.width = width;
    this.height = height;
    this.offsetX = offsetX;
    this.offsetY = offsetY;
    this.mode = mode;
    this.lang = lang;
    this.player = new Player({ app: {token: "TcA8uaS3v2TKzWRW"}});

    
    if (!canvasCtx.roundRect){
      alert("現在のブラウザは古すぎるため、このゲームをサポートしていません。ブラウザを更新するか、別のブラウザをご利用ください。\nThe current browser is too old and is not supported by the game. Please update your browser or change to a different one.");
      window.close();
    }

    const testAudio = document.createElement('audio')
    testAudio.volume = 0.5
    setTimeout(() => {
      if (testAudio.volume != 0.5){
        alert("iOSの制限により、ゲーム内の音声が正しくフェードイン・フェードアウトしない可能性があります。\nDue to iOS constraints, the audio will not fade in and out properly in the game.")
      }
    }, 100);
    // this.setActiveScreen('intro');
  }
  
  async load(){
    const promises = [new Promise(async(resolve, reject) => {
      try{
        console.log("Fetching Songs...");
        this.songData = await (await fetch('./assets/data/songs.json')).json();
        while(this.player.isLoading){
          console.log("Waiting for player...");
          await sleep(500);
        }
        // console.log("Player Ready! Caching all track data...");
        // try{
        //   for (let i = 0; i < this.songData.length; i++){
        //     await this.player.createFromSongUrl(...this.songData[i].textAliveData);
        //   }
        // }
        // catch(e){
        //   console.error(e);
        //   console.warn("Failed to cache all track data, waiting 2 seconds and continuing...");
        //   await sleep(2000);
        // }
        // this.player.addListener('onPause', (event) => event.preventDefault());
        

        console.log("Player Ready! Caching first song...");
        this.player.volume = 0;
        let wait_counter = 2;
        while (!this.currentSongData){
          try{
            this.currentSongData = await this.player.createFromSongUrl(...this.songData[0].textAliveData);
          }
          catch(e){
            if (wait_counter >= 8){
              alert(`エラー：${this.songData[this.selectedSongIndex].title} の読み込みに7回失敗しました。アプリを再起動してください！\nERROR: FAILED TO LOAD ${this.songData[0].title} AFTER 7 ATTEMPTS! PLEASE RESTART THE APP!`)
              throw e;
            }
            console.error(e);
            console.warn(`Attempting to load first song again in ${wait_counter} seconds...`)
            await sleep(wait_counter*1000);
            wait_counter++;
          }
        }
        // Fix player control problem on mobile 
        // For some reason, if I don't force the song to reload, the app won't work on mobile browsers
        this.currentSongData = undefined

        // console.dir(this.player);
        console.log("Player loaded successfully!")
        resolve()
      }
      catch(e){
        reject(e);
      }
    })];
    console.dir(promises);
    for (let key in this.icons){
      promises.push(this.icons[key].load())
    }
    for (let key in this.images){
      promises.push(this.images[key].load())
    }
    await Promise.all(promises); 
    // console.dir(this.songData);
  }

  updateScreenRes(width, height, offsetX, offsetY){
    this.width = width;
    this.height = height;
    this.offsetX = offsetX;
    this.offsetY = offsetY;
    for (let i = 0; i < this.activeScreens.length; i++){
      this.activeScreens[i].screenState.width = width;
      this.activeScreens[i].screenState.height = height;
      this.activeScreens[i].screenState.offsetX = offsetX;
      this.activeScreens[i].screenState.offsetY = offsetY;
    }
  }

  setActiveScreen(screenName, screenArgs){
    this.activeScreens[0]?.startOutroTransition();
    const newScreen = new Screen(new ScreenState(this.canvasCtx, 0, 0, this.width, this.height, this.offsetX, this.offsetY, this.mode, this.lang, this.player ? this.player.timer.position : undefined), screenArgs ? this.screens[screenName](...screenArgs) : this.screens[screenName]())
    newScreen.startIntroTransition();
    this.activeScreens.unshift(newScreen)
    this.currentlyActiveScreen = screenName;
  }

  icons = /** @type { {[id: string] : () => SVG[]} } */ ({
    'play': new SVG('./assets/icons/play_arrow_24dp_E3E3E3_FILL1_wght400_GRAD0_opsz24.svg'),
    'prev': new SVG('./assets/icons/skip_previous_24dp_E3E3E3_FILL1_wght400_GRAD0_opsz24.svg'),
    'next': new SVG('./assets/icons/skip_next_24dp_E3E3E3_FILL1_wght400_GRAD0_opsz24.svg'),
    'note': new SVG('./assets/icons/music_note_24dp_E3E3E3_FILL1_wght400_GRAD0_opsz24.svg'),
    'headphones': new SVG('./assets/icons/headphones_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg'),
    'piano': new SVG('./assets/icons/piano_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg'),
    'radio': new SVG('./assets/icons/radio_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg'),
    'speaker': new SVG('./assets/icons/speaker_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg'),
    'album': new SVG('./assets/icons/album_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg'),
    'volume_up': new SVG('./assets/icons/volume_up_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg'),
    'graphic_eq': new SVG('./assets/icons/graphic_eq_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg'),
    'instant_mix': new SVG('./assets/icons/instant_mix_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg')
  });

  images = /** @type { {[id: string] : () => PNG[]} } */ ({
    'miku_webcam_example': new PNG('./assets/images/Miku Webcam Example With Webcam Monitor Frame Final Compressed v2.png'),
    'rin_and_len_webcam_example': new PNG('./assets/images/Rin And Len Webcam Example With Webcam Monitor Frame Final Compressed v2.png'),
    'kaito_webcam_example': new PNG('./assets/images/Kaito Example No BG Compressed.png'),
  })

  /**
   * Translates the difficulty label if required based on current settings.
   * @param {string} difficultyText 
   * @returns Translated Difficulty Label
   */
  translateDifficultyText(difficultyText){
    if (this.lang == 'jp'){
      if (difficultyText.trim().toLowerCase() == 'easy'){
        return '簡単'
      }
      else if (difficultyText.trim().toLowerCase() == 'intermediate'){
        return '中級'
      }
      else if (difficultyText.trim().toLowerCase() == 'hard'){
        return '難しい'
      }
    }
    else{
      return difficultyText
    }
  }

  screens = /** @type { {[id: string] : () => Drawable[]} } */({
    'intro': () => [
      new GameManual(this.images['miku_webcam_example'], this.images['rin_and_len_webcam_example'], this.images['kaito_webcam_example']),
      new Text(1420/2, 140, "タップタップ", rgb(255, 87, 20), rgb(255, 87, 20), true, 96, undefined, 'center'),
      new CircularButton(1420/2, 261, 50, "Start", ()=> {
        console.log('start');
        this.setActiveScreen('select_music');
      })
    ],
    // 'test': () => [
    //   new ScoreBoard(60000, 67000, 23, 52.3, [1,1,1,1,1,0,0,1,1,1,0,1,1,0,0,1,1,1,1,0,1,1,0,1], ()=>{})
    // ],
    'select_music': () => {
      // let songIndex = 0;
      let loadingCount = 0;
      const findLongestSegment = (segments) => {
        let longestStart = 0;
        let longestDuration = 0;
        let currentChunkStart;
        let currentChunkEnd;
        for (let i = 0; i < segments.length; i++){
          if (!currentChunkStart || segments[i].startTime != currentChunkEnd){
            currentChunkStart = segments[i].startTime;
            currentChunkEnd = segments[i].endTime;
          }
          else if (currentChunkEnd == segments[i].startTime){
            currentChunkEnd = segments[i].endTime;
          }
          if ((currentChunkEnd - currentChunkStart) > longestDuration){

            longestDuration = currentChunkEnd - currentChunkStart;
            longestStart = currentChunkStart;
            
          }
        }
        return [longestStart, longestDuration];
      } 
      const albumArtElm = new AlbumArt(this.icons['note'], this.songData[0].title, this.songData[0].artist, this.translateDifficultyText(this.songData[0].difficulty), this.player, shuffleArray([this.icons['note'],this.icons['headphones'], this.icons['piano'], this.icons['radio'], this.icons['speaker'], this.icons['album'], this.icons['volume_up'], this.icons['graphic_eq'], this.icons['instant_mix']]));
      this.playerButtons = new Array();
      let playBtn, prevBtn, nextBtn;
      const updateAlbum = async () => {
        albumArtElm.title = this.songData[this.selectedSongIndex].title;
        albumArtElm.artist = this.songData[this.selectedSongIndex].artist;
        albumArtElm.difficulty = this.translateDifficultyText(this.songData[this.selectedSongIndex].difficulty);
        loadingCount++;
        playBtn.disabled = true;
        prevBtn.disabled = true;
        nextBtn.disabled = true;
        playBtn.loading = true;
        // const queue_number = loadingCount;
        // while (loadingCount > 1){
        //   if (loadingCount != queue_number){
        //     console.warn(`Song ${this.songData[this.selectedSongIndex].title} waiting in queue ${queue_number}/${loadingCount} for execution. Waiting 2 seconds...`)
        //     await sleep(2000);
        //   }
        // }
        if (!albumArtElm.currentSongPreviewStart || !albumArtElm.currentSongPreviewEnd){
          if (!this.currentSongData){
            this.currentSongData = await this.player.createFromSongUrl(...this.songData[this.selectedSongIndex].textAliveData);
          }
          const [previewStartTime, previewDuration] = findLongestSegment(this.player.getChoruses());
          console.dir({previewStartTime, previewDuration});
          console.log(previewStartTime + previewDuration);
          albumArtElm.currentSongPreviewStart = previewStartTime -500;
          albumArtElm.currentSongPreviewEnd = (previewStartTime + previewDuration);
          this.player.requestMediaSeek(previewStartTime - 500);
          this.player.requestPlay();
          // console.dir(albumArtElm);
          loadingCount--;
          if (loadingCount <= 0){
            playBtn.disabled = false;
            prevBtn.disabled = false;
            nextBtn.disabled = false;
            playBtn.loading = false;
            console.dir(playBtn);
          }
        }
        else{
          albumArtElm.changeSongCallback = async () => {
            console.log('callbackRunning')
            try{
              this.player.requestStop();
              let wait_counter = 2;
              while (true){
                try{
                  this.currentSongData = await this.player.createFromSongUrl(...this.songData[this.selectedSongIndex].textAliveData);
                  break;
                  // const prevSongData = this.currentSongData;
                  // this.currentSongData = await this.player.createFromSongUrl(...this.songData[this.selectedSongIndex].textAliveData);
                  // if (this.currentSongData.duration != prevSongData.duration || this.currentSongData.charCount != prevSongData.charCount){// Check if the new song has loaded.
                  //   break
                  // }
                  // else{
                  //   throw Error("new song cannot load yet")
                  // }
                }
                catch(e){
                  if (wait_counter >= 8){//User has waited at least 27 seconds already!
                    alert(`エラー：${this.songData[this.selectedSongIndex].title} の読み込みに7回失敗しました。アプリを再起動してください！\nERROR: FAILED TO LOAD SONG ${this.songData[this.selectedSongIndex].title} AFTER 7 ATTEMPTS! PLEASE RESTART THE APP!`);
                    loadingCount--;
                    playBtn.disabled = true;
                    prevBtn.disabled = false;
                    nextBtn.disabled = false;
                    playBtn.loading = false;
                    throw e;
                  }
                  console.error(e);
                  console.warn(`Attempting to load music again in ${wait_counter} seconds...`)
                  await sleep(wait_counter*1000);
                  wait_counter++;
                }
              }
              const [previewStartTime, previewDuration] = findLongestSegment(this.player.getChoruses());
              albumArtElm.currentSongPreviewStart = previewStartTime - 500;
              albumArtElm.currentSongPreviewEnd = previewStartTime + previewDuration;
              this.player.requestMediaSeek(previewStartTime - 500);
              this.player.requestPlay();
              albumArtElm.lastLoopTrigger = undefined;
              loadingCount--;
              if (loadingCount <= 0){
                playBtn.disabled = false;
                prevBtn.disabled = false;
                nextBtn.disabled = false;
                playBtn.loading = false;
                console.dir(playBtn);
              }
            }
            catch (e){
              console.error(e);
            }
          }
        }
      }
      playBtn = new IconButton(1420/2, 590, 50, this.icons['play'], "Play", ()=> {
        console.log('music_select');
        albumArtElm.playPressed = true;
        for (let i; i < this.playerButtons.length; i++){
          this.playerButtons[i].disabled = true;
        }
        albumArtElm.stopMusicNow();
        if (!this.currentSongData){// Should not happen unless in testing.
          this.player.createFromSongUrl(...this.songData[this.selectedSongIndex].textAliveData).then((data) => this.setActiveScreen('game', [data, this.songData[this.selectedSongIndex]]));
        }
        else{
          this.setActiveScreen('game', [this.currentSongData, this.songData[this.selectedSongIndex]]);
        }
      })
      prevBtn = new IconButton(1420/2 - 150, 590, 30, this.icons['prev'], "Previous", ()=> {
        console.log('music_prev');
        this.selectedSongIndex = this.selectedSongIndex > 0 ? this.selectedSongIndex-1 : this.songData.length-1;
        albumArtElm.stopMusicNow();
        updateAlbum();
      });
      nextBtn = new IconButton(1420/2 + 150, 590, 30, this.icons['next'], "Next", ()=> {
        console.log('music_next');
        this.selectedSongIndex = this.selectedSongIndex+1 < this.songData.length ? this.selectedSongIndex+1 : 0; 
        albumArtElm.stopMusicNow();
        updateAlbum();
      })
      updateAlbum();
      return [
        albumArtElm,
        new CircularButton(1420/8, 75, 50, this.lang == 'jp' ? "戻る" : "back", ()=> {
          console.log('back');
          albumArtElm.stopMusicNow();
          this.setActiveScreen('intro');
          setTimeout(() => {
            if (this.currentlyActiveScreen == 'intro'){
              this.player.requestPause()
            }
          }, 750)
        }),
        playBtn,
        prevBtn,
        nextBtn
      ]},
    // 'game_temp': () => {
    //   const pointCounter = new PointsCounter('TEST',undefined, 0);
    //   setTimeout(() => {pointCounter.duration = 60000}, 3000)
    // return [
    //   pointCounter
    // ]},
    /**
     * 
     * @param {import("textalive-app-api").IVideo} selectedTrackData 
     */
    'game': (selectedTrackData, songData) => {
      const pointCounter = new PointsCounter(this.icons['note'] ,songData.title, songData.artist, this.translateDifficultyText(songData.difficulty), selectedTrackData.duration, 0, songData.segmentationColoursData);
      // Score
      let score = 0;
      // Combo
      let combo = 0;
      let highestCombo = 0;
      // Average Reaction Time
      let totalReactTime = 0;
      let totalClickedWordCount = 0;
      // Combo Bar & Missed Words Count
      let comboData = new Array();
      // const maxLyricfluctuation = this.height/4;
      console.dir(selectedTrackData);
      const punctuations = ["！", "？", "、", "," , "！)", "！）", "？)", "？）", "!", "…"];
      const removablePunctuations = ["（", "(", ")", "）", "\"", "「", "」", "“", "”"];
      const waitForSongTiming = (songTime, callback) => {
        const currentTime = this.player.timer.position;
        setTimeout(() => {
          const currentTimeNew = this.player.timer.position;
          if (currentTimeNew < songTime){
            waitForSongTiming(songTime, callback);
          }
          else{
            callback();
          }
        }, songTime - currentTime)
      }
      /**
       * 
       * @param {import("textalive-app-api").IPhrase} phraseData 
       */
      const renderPhrase = (phraseData) => {
        const currentTime = this.player.timer.position;
        const newPhraseChildren = new Array();
        for (let i=0;i < phraseData.children.length; i++){
          if(phraseData.children[i+2] && (phraseData.children[i+1].text === "'" || phraseData.children[i+1].text === "’")){
            newPhraseChildren.push({
              text: phraseData.children[i].text + phraseData.children[i+1].text + phraseData.children[i+2].text,
              startTime: phraseData.children[i].startTime,
              duration: phraseData.children[i+2].endTime - phraseData.children[i].startTime
            })
            i+=2;
          }
          else if (phraseData.children[i+1] && punctuations.includes(phraseData.children[i+1].text[0])){
            newPhraseChildren.push({
              text: phraseData.children[i].text + phraseData.children[i+1].text[0],
              startTime: phraseData.children[i].startTime,
              duration: phraseData.children[i+1].endTime - phraseData.children[i].startTime
            })
            i++;
          }
          else if (!removablePunctuations.includes(phraseData.children[i].text)){
            if (phraseData.children[i+1] && removablePunctuations.includes(phraseData.children[i+1].text)){
              newPhraseChildren.push({
                text: phraseData.children[i].text,
                startTime: phraseData.children[i].startTime,
                duration: phraseData.children[i+1].endTime - phraseData.children[i].startTime
              })
              i++;
            }
            else{
              newPhraseChildren.push({
                text: phraseData.children[i].text,
                startTime: phraseData.children[i].startTime,
                duration: phraseData.children[i].duration
              })
            }
          }
        }
        const splitLength = 1420/(newPhraseChildren.length + 1);
        // maxScore += newPhraseChildren.length * 100;
        let prevYpos;
        const allowedWordJump = songData.wordMappingVariance;
        for(let i=0; i < newPhraseChildren.length; i++){
          const xPos = splitLength*(i+1);
          let yPos;
          let maxPossibleYpos = prevYpos ? Math.min(prevYpos+allowedWordJump, 650) : 650;
          let minPossibleYpos;
          if (xPos < 300 || xPos > this.width - 200){// TODO: Do a proper measurment of the pointsContainer
            minPossibleYpos = prevYpos ? Math.max(prevYpos-allowedWordJump, 200): 200;
          }
          else{
            minPossibleYpos = prevYpos ? Math.max(prevYpos-allowedWordJump, 80): 80;
          }
          // MIN MAX Just in case
          yPos = RandomNumber(Math.min(maxPossibleYpos, minPossibleYpos), Math.max(maxPossibleYpos, minPossibleYpos));
          prevYpos = yPos;
          
          this.activeScreens[0].push(new Word(newPhraseChildren[i].text, xPos, yPos, newPhraseChildren[i].startTime, newPhraseChildren[i].duration, currentTime, songData.wordSpeed, (self_word)=>{
            console.log(`Pressed: ${newPhraseChildren[i].text}`);
            score += 100;
            combo++;
            comboData.push(true);
            highestCombo = Math.max(highestCombo, combo);
            totalClickedWordCount++;
            totalReactTime += (self_word.currentPlayerPosition - self_word.startTime);
            pointCounter.combo = combo;
            pointCounter.score = score;
          }, () => {
            combo = 0;
            comboData.push(false);
            pointCounter.combo = combo;
          }))
          // setTimeout(()=> {
          //   console.log(phraseData.children[i].text)
          // }, phraseData.children[i].startTime - currentTime)
        }
        if (phraseData.next){
          const nextTime = phraseData.endTime - songData.wordSpeed - 100;//Added extra 100 just in case.
          if (nextTime - currentTime <= 0){
            renderPhrase(phraseData.next)
          }
          else{
            // setTimeout(() => renderPhrase(phraseData.next), nextTime - currentTime)
            waitForSongTiming(nextTime, () => renderPhrase(phraseData.next))
          }
        }
        else{
          const showStats = () => {
            const maxScore = comboData.length*100
            console.log(`Score: ${score}/${maxScore} (${score/maxScore*100}%)`);
            console.log(`Max Combo: ${highestCombo}`);
            console.log(`Average Response Time: ${totalReactTime/totalClickedWordCount}ms`);
            pointCounter.outroTimestamp = true;
            this.activeScreens[0].push(
              new ScoreBoard(score, maxScore, highestCombo, totalReactTime/totalClickedWordCount, comboData, ()=>{
                this.setActiveScreen('select_music');
              })
            )
            // this.activeScreens[0].push(
            //   new Text(1420/2, 730/2, `Score: ${score}/${maxScore} (${Math.floor(score/maxScore*100)}%)`, 'rgb(234, 12, 96)', undefined, true, 48, undefined, 'center', 'middle')
            // )
            // this.activeScreens[0].push(
            //   new CircularButton(1420/2, 730/2 + 100, 50, "Exit", () => {
            //     this.setActiveScreen('select_music');
            //     // if (this.player.isPlaying){
            //     //   this.player.requestStop();
            //     // }
            //   })
            // )
          }
          waitForSongTiming(phraseData.endTime, showStats);
        }
      }
      setTimeout(()=> {
        // this.player.volume = 0;
        this.player.requestStop();
        this.player.requestMediaSeek(0);
        // this.player.requestPause();
        this.player.volume = 100;
      }, 1000)
      setTimeout(async ()=> {
        while (this.player.timer.position != 0){
          await sleep(100);
        }
        this.player.requestPlay();
        // pointCounter.duration = selectedTrackData.duration;
        console.dir(selectedTrackData)
        renderPhrase(selectedTrackData.firstPhrase)
        // const nextTime = selectedTrackData.firstPhrase.startTime - 1000;
        // if (nextTime > 0){
        //   setTimeout(()=> {
        //     renderPhrase(selectedTrackData.firstPhrase)
        //   }, nextTime)
        // }
        // else{
        //   renderPhrase(selectedTrackData.firstPhrase)
        // }
      }, 4000);
      return [pointCounter];
    }
  })


  /**
   * Renders the Game onto the canvas
   * @param {number} animationStep 
   * @param {Cursor[]} cursors A list of cursor objects
   * @param {RenderableSegmentationMask | undefined} segmentationMask The Segmentation Mask if avaliable
   */
  renderScreen(animationStep, cursors, segmentationMask){
    const removableScreensIndexes = new Array();
    for (let i = this.activeScreens.length-1; i >= 0; i--){// iterate backwards so that new screen displays above old screen. 
      if (i != 0 && this.activeScreens[i].screenState.transitionProgress <= 0 && this.activeScreens[i].transitionState == 'idle'){
        removableScreensIndexes.push(i)
      }
      else{
        this.activeScreens[i].render(animationStep, cursors, this.player ? this.player.timer.position : undefined, segmentationMask);
      }
    }

    for (let i = 0; i < removableScreensIndexes.length; i++){
      this.activeScreens.splice(removableScreensIndexes[i] - i);
    }
  }

}

export default MainGame;